// components/PropertyBasicDetails.js
import React from 'react';
import Select from 'react-select';

const PropertyBasicDetails = ({
    formData,
    errors,
    propertyTypeOptions,
    listingTypeOptions,
    furnishingStatusOptions,
    ownershipTypesOptions,
    availabilityStatusOptions,
    facingDirectionsOptions,
    propertyTypeSelectedFields,
    handleInputChange,
    updatePropertyTypeFields,
    updateListingTypeFields,
}) => {
    return (
        <>
            <div className="form-group mb-3 col-12">
                <label className="form-label">Property Title</label>
                <input
                    type="text"
                    className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                    placeholder="Property Title"
                    required
                    value={formData.title}
                    onChange={(e) => handleInputChange('title', e.target.value)}
                />
                {errors.title && <div className="invalid-feedback">{errors.title}</div>}
            </div>
            <div className="mb-3 col-12">
                <label className="form-label">Property Description</label>
                <textarea
                    className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                    rows="4"
                    required
                    value={formData.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                />
                {errors.description && <div className="invalid-feedback">{errors.description}</div>}
            </div>
            <div className="mb-3 col-lg-4 col-md-6">
                <label className="form-label">Listing Type</label>
                <div className={`form-group ${errors.listingTypeId ? 'is-invalid' : ''}`}>
                    <Select
                        options={listingTypeOptions}
                        className="custom-react-select"
                        isSearchable={false}
                        value={listingTypeOptions.find(opt => opt.value === formData.listingTypeId)}
                        onChange={(selected) => {
                            handleInputChange('listingTypeId', selected.value);
                            updateListingTypeFields(selected.value);
                        }}
                    />
                    {errors.listingTypeId && (
                        <div className="invalid-feedback d-block">{errors.listingTypeId}</div>
                    )}
                </div>
            </div>
            <div className="mb-3 col-lg-4 col-md-6">
                <label className="form-label">Property Type</label>
                <div className={`form-group ${errors.propertyTypeId ? 'is-invalid' : ''}`}>
                    <Select
                        options={propertyTypeOptions}
                        className="custom-react-select"
                        isSearchable={false}
                        value={propertyTypeOptions.find(opt => opt.value === formData.propertyTypeId)}
                        onChange={(selected) => {
                            handleInputChange('propertyTypeId', selected.value);
                            updatePropertyTypeFields(selected.value);
                        }}
                    />
                    {errors.propertyTypeId && (
                        <div className="invalid-feedback d-block">{errors.propertyTypeId}</div>
                    )}
                </div>
            </div>
            {propertyTypeSelectedFields.includes("furnishedStatus") && (
                <div className="mb-3 col-lg-4 col-md-6">
                    <label className="form-label">Furnished Status</label>
                    <Select
                        options={furnishingStatusOptions}
                        className="custom-react-select"
                        isSearchable={false}
                        value={furnishingStatusOptions.find(opt => opt.value === formData.furnishingStatusId)}
                        onChange={(selected) => handleInputChange('furnishingStatusId', selected.value)}
                    />
                </div>
            )}
            <div className="mb-3 col-lg-4 col-md-6">
                <label className="form-label">Ownership Type</label>
                <Select
                    options={ownershipTypesOptions}
                    className="custom-react-select"
                    isSearchable={false}
                    value={ownershipTypesOptions.find(opt => opt.value === formData.ownershipTypeId)}
                    onChange={(selected) => handleInputChange('ownershipTypeId', selected.value)}
                />
            </div>
            <div className="mb-3 col-lg-4 col-md-6">
                <label className="form-label">Availability Status</label>
                <Select
                    options={availabilityStatusOptions}
                    className="custom-react-select"
                    isSearchable={false}
                    value={availabilityStatusOptions.find(opt => opt.value === formData.availabilityStatusId)}
                    onChange={(selected) => handleInputChange('availabilityStatusId', selected.value)}
                />
            </div>
            {propertyTypeSelectedFields.includes("facingDirection") && (
                <div className="mb-3 col-lg-4 col-md-6">
                    <label className="form-label">Facing Direction</label>
                    <Select
                        options={facingDirectionsOptions}
                        className="custom-react-select"
                        isSearchable={false}
                        value={facingDirectionsOptions.find(opt => opt.value === formData.facingDirectionId)}
                        onChange={(selected) => handleInputChange('facingDirectionId', selected.value)}
                    />
                </div>
            )}
            {propertyTypeSelectedFields.includes("propertyAge") && (
                <div className="mb-3 col-lg-4 col-md-6">
                    <label className="form-label">Property Age</label>
                    <input
                        type="number"
                        className="form-control"
                        placeholder="Property Age"
                        required
                        value={formData.propertyAge}
                        onChange={(e) => handleInputChange('propertyAge', e.target.value)}
                    />
                </div>
            )}
        </>
    );
};

export default PropertyBasicDetails;
